import { render, staticRenderFns } from "./Readonly.vue?vue&type=template&id=37ef757a&"
import script from "./Readonly.vue?vue&type=script&lang=js&"
export * from "./Readonly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports